<template>
  <ancestryline-modal title="modal.confirmation.title"  id="confirmation-modal" :close="doNothing">

    <div class="p-grid p-col-12 align-center">
      <div class="p-col-12 align-center">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 1.3rem;color: orange;"/><span style="font-size: 1.3rem;">{{isShowDefaultMessage ? $t('modal.confirmation.message') : $t(message)}}</span>
      </div>
      <h3 v-for="client in clients" :key="client.id" class="p-col-12 clients-list">
        <a class="cursor-pointer" target="_blank" :href="`#/client/${client.id}/details`">{{client.name}}</a> - <Button class="p-mr-2 p-mb-2 p-button p-component" @click.prevent="selectClient(client)">{{ $t('forms.client.useClient') }}</button>
      </h3>
    </div>

    <template #footer>
      <div class="p-col-12">
      <Button class="float-left p-button-outlined p-button-secondary p-mr-2" @click="close(false)">{{$t('btn.cancel')}}</Button>
      <Button class="p-mr-2 p-mb-2 p-button p-component float-right" @click="close(true)">
            <span class="p-button-label">
              <i class="pi pi-check p-mr-2"></i>{{$t('btn.confirm')}}
            </span>
      </Button>
    </div>
    </template>
  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import Utils from "@/utils/Utils";

export default {

  name: "ClientDuplicateConfirmation",

  props: {
      message: null,
      clients: null,
  },

  computed: {
    isShowDefaultMessage(){
      return Utils.isEmptyNullOrUndefined(this.message);
    }
  },

  methods:{

    doNothing() {

    },

    selectClient(client) {
      DialogService.closeModal(client);
    },

    close(confirm){
      DialogService.closeModal(confirm);
    }
  }
}
</script>

<style scoped>

.align-center {
  align-items: center;
  text-align: center;
}

.modal-body {
  min-height: 250px !important;
}

.clients-list {
  align-items: center;
  display: flex;
  justify-content: center;
}

</style>